const menuItems = [
  { link: 'https://gojitsu.com/services', title: 'SERVICES' },
  { link: 'https://gojitsu.com/industry', title: 'INDUSTRIES' },
  { link: 'https://gojitsu.com/tracking', title: 'TRACKING', isActive: true },
  { link: 'https://gojitsu.com/api', title: 'API' },
];

export default menuItems;
